var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosthog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    fill: "none",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9BD2B",
    d: "M33 179.379L72.0038 218.33H33V179.379ZM33 169.641L81.7548 218.33H120.759L33 130.689V169.641ZM33 120.951L130.51 218.33H169.513L33 82V120.951ZM81.7548 120.951L179.264 218.33V179.379L81.7548 82V120.951ZM130.51 82V120.951L179.264 169.641V130.689L130.51 82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M267.023 202.75C257.03 202.75 247.451 198.784 240.391 191.734L186.16 137.576V218.33H267.023V202.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.563 202.75C213.871 202.75 217.363 199.262 217.363 194.959C217.363 190.657 213.871 187.169 209.563 187.169C205.254 187.169 201.762 190.657 201.762 194.959C201.762 199.262 205.254 202.75 209.563 202.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D4AFF",
    d: "M33 218.33H72.0038L33 179.379V218.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D4AFF",
    d: "M81.7548 130.689L33 82V120.951L81.7548 169.641V130.689Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D4AFF",
    d: "M33 130.689V169.641L81.7548 218.33V179.379L33 130.689Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F54E00",
    d: "M130.51 130.689L81.7548 82V120.951L130.51 169.641V130.689Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F54E00",
    d: "M81.7548 218.33H120.759L81.7548 179.379V218.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F54E00",
    d: "M81.7548 130.689V169.641L130.51 218.33V179.379L81.7548 130.689Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosthog);
export default __webpack_public_path__ + "static/media/posthog.4e4277770e28182197787523bd2b47bb.svg";
export { ForwardRef as ReactComponent };